import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-593c2f17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-top" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "top-list" }
const _hoisted_4 = { class: "home" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "欢迎来到文品易通", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 本系统基于用户提供的论文可自动生成对应的论文检测评价与相应的报告。报告包括论文字数、问题总数、问题描述、错误位置、文字差错率等检测内容 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_8 = { class: "dialog-header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提示", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 文品易通暂不支持在移动设备上实现检测服务，敬请用户通过电脑访问并使用相关功能。电脑端访问地址：wpyt.microcomputation.com。 ", -1))
const _hoisted_11 = { class: "dialog-footer" }

import { ref, onMounted } from "vue";
import { getUser } from "@/service/personalCenter/request.js";
import { useRoute, useRouter } from "vue-router";
import { setLocal } from "@/service/common.js";
import mitt from "@/service/mitt.js";
import { ElMessage } from "element-plus";
import useClipboard from "vue-clipboard3";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPc',
  setup(__props) {

const { toClipboard } = useClipboard();
const router = useRouter();
const checkNum = ref(); // 用户剩余次数
const checkDialogVisible = ref(false); // 移动端开始检测弹窗

// 获取用户信息
const getUserInfo = async () => {
  const res = await getUser();
  if (res && res.code && res.code == 200) {
    checkNum.value = res.data.checkNum;
    //调用传值
    mitt.emit("checkNum", checkNum.value);
    setLocal("checkNum", checkNum.value);
  }
};

const handCopy = () => {
  checkDialogVisible.value = false;
  toClipboard("wpyt.microcomputation.com");
  ElMessage({
    message: "复制成功",
    type: "success",
  });
};

onMounted(() => {
  getUserInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_FirstAidKit = _resolveComponent("FirstAidKit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Promotion = _resolveComponent("Promotion")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 10
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _hoisted_6,
                  _createVNode(_component_el_button, {
                    size: "large",
                    color: "#0054fe",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/paper_detection')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FirstAidKit)
                        ]),
                        _: 1
                      }),
                      _createTextVNode("开始检测")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_link, {
                    underline: false,
                    href: "http://www.moe.gov.cn",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "large",
                        color: "#0054fe"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Promotion)
                            ]),
                            _: 1
                          }),
                          _createTextVNode("教育部官网 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    class: "check-button",
                    color: "#0054fe",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (checkDialogVisible.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("开始检测")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 12,
                sm: 12,
                md: 12,
                lg: 10
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_dialog, {
            modelValue: checkDialogVisible.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checkDialogVisible).value = $event)),
            title: "提示",
            width: "80%",
            center: ""
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_WarningFilled)
                  ]),
                  _: 1
                }),
                _hoisted_9
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_button, {
                  color: "#0054fe",
                  onClick: handCopy
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 复制地址 ")
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}
}

})